module.exports = __webpack_public_path__ + "static/media/micImg.3811c6b7.png";